import React, {Fragment,} from "react";
import {Button} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import Typography from '@material-ui/core/Typography';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {searchGroups} from "../../../api/pro-guest-functions";
import {TableLoadingRow} from "../../ui/table/TableLoadingRow";
import {makeStyles} from "@material-ui/core/styles/index";
import {useMediaQuery} from "@material-ui/core/index";
import {useTheme} from "@material-ui/core/styles";
import Hidden from '@material-ui/core/Hidden';
import GroupIcon from '@material-ui/icons/Group';
import {withLazyDynamicTable} from "../../ui/hoc/LazyDynamicTable";
import {TableEmptyRow} from "../../ui/table/TableEmptyRow";

const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    actionColumn: {
        maxWidth: 150,
        width: 100
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    groupColumn: {
        minWidth: 120
    }
}));


const _ProGroups = ({
                        organizationId,
                        folderId,
                        data: groups,
                        loading
                    }: any) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    const openGroup = (group: any) => {
        navigate(`/pro-guests/groups/${group.id}/edit?folderId=${folderId}`);
    };

    return (
        <Fragment>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.avatarColumn}></TableCell>
                    <TableCell>{t('ProGuest.Groups.Table.Headers.Name')}</TableCell>
                    <TableCell className={classes.actionColumn}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    loading ? <TableLoadingRow/> :
                        groups.length === 0 ?
                            <TableEmptyRow messageKey='ProGuest.Groups.Table.EmptyMessage'/> :
                            groups.map((group: any) => <TableRow onClick={() => isMobile && openGroup(group)}
                                                                 key={`${group.id}`}>
                                <TableCell component="th" scope="row" className={classes.avatarColumn}>
                                    <GroupIcon/>
                                </TableCell>
                                <TableCell className={classes.groupColumn}>
                                    <Typography variant="body1">{group.name}</Typography>
                                </TableCell>
                                <TableCell className={classes.actionColumn} align="center">
                                    <Button color="primary" size="small"
                                            onClick={() => openGroup(group)}>
                                        {t('_Common.Labels.Open')}
                                    </Button>
                                </TableCell>
                            </TableRow>)
                }
            </TableBody>
        </Fragment>
    );
};

export const ProGroups = (properties: any) => {
    const {organizationId, folderId} = properties;
    const query = (paginationParams: any) => searchGroups({organizationId, folderId, ...paginationParams});
    return withLazyDynamicTable(_ProGroups, query, ['organizationId', 'folderId'])(properties);
};
